import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Text,
  TableCell,
} from "grommet";

export class TaskOverviewTable extends Component {
  state = {
    tableRows: [],
  };

  updateRowData = () => {
    let tableRows = [];
    let tableRowElement;

    const shiftGuards = this.props.shiftData.Shift_Gaurds;
    if (typeof shiftGuards === "object") {
      shiftGuards.forEach((shiftGuard) => {
        if (typeof shiftGuard.TaskInstances === "object") {
          shiftGuard.TaskInstances.forEach((taskInstance) => {
            const timeTaken =
              (new Date(taskInstance.EndDateTime) -
                new Date(taskInstance.StartDateTime)) /
              1000;
            const time = this.getStringFromSeconds(timeTaken);
            const startTime = this.getPrettyDateString(
              taskInstance.StartDateTime
            );
            const endTime = this.getPrettyDateString(taskInstance.EndDateTime);
            tableRowElement = {
              guardName: shiftGuard.Gaurd.GaurdFirstName,
              startTime: startTime,
              endTime: endTime,
              timeTaken: time,
              taskName: taskInstance.Task.Name,
            };
            tableRows.push(tableRowElement);
          });
        }
      });
    }

    const newState = {
      ...this.state,
      tableRows: tableRows,
    };
    this.setState(newState);
  };

  componentWillMount = () => {
    this.updateRowData();
  };

  getStringFromSeconds = (timeTaken) => {
    const hours = Math.floor(timeTaken / 3600);
    timeTaken %= 3600;
    const minutes = Math.floor(timeTaken / 60);
    const seconds = timeTaken % 60;

    let minuteString;
    let secondString;
    let hoursString;

    if (hours < 10) {
      hoursString = "0" + hours;
    } else {
      hoursString = "" + hours;
    }

    if (minutes < 10) {
      minuteString = "0" + minutes;
    } else {
      minuteString = "" + minutes;
    }

    if (seconds < 10) {
      secondString = "0" + seconds;
    } else {
      secondString = "" + seconds;
    }

    const timeString = hoursString + ":" + minuteString + ":" + secondString;
    return timeString;
  };

  getPrettyDateString = (dateString) => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  render() {
    const tableRows = this.state.tableRows;
    return (
      <Box>
        <Table>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Guard Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                Task Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                Task Start Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Task End Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Time Taken
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tableRows.map((tableRow, index) => {
              return (
                <TableRow key={index}>
                  <TableCell scope="row">
                    <Text>{tableRow.guardName}</Text>
                  </TableCell>
                  <TableCell scope="row">
                    <Text>{tableRow.taskName}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.startTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.endTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.timeTaken}</Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default TaskOverviewTable;
